/** 后端路径与前端路由的映射 */
export const PATH_ALIAS = {
  "/cources": "/course",
  "/cources/list": "/course",
  "/user/manager": "/system/user",
  "/role": "/system/role",
  "/menu": "/system/menu",
  "/dict": "/system/dict",
  "/list/enter": "/question/theory",
  "/user/train": "/student/index",
  // 教师端菜单路径
  "/home": "/home",
  "/course": "/course",
  "/question": "/question",
  "/question/theory": "/question/theory",
  "/question/practical": "/question/practical",
  "/knowledge": "/Knowledge",
  "/Knowledge": "/Knowledge",
  "/news": "/news"
};

export function normalizePath(path) {
  if (!path) return "";
  let normalized = String(path).replace(/\/+/g, "/");
  if (normalized.length > 1 && normalized.endsWith("/")) {
    normalized = normalized.slice(0, -1);
  }
  return normalized;
}

export function mapToAppPath(path) {
  const normalized = normalizePath(path);
  return PATH_ALIAS[normalized] || normalized;
}

export function resolveFullPath(parentPath, childPath) {
  const parent = normalizePath(parentPath);
  const child = normalizePath(childPath);
  if (!child) return parent;
  if (child.startsWith("/")) return mapToAppPath(child);
  if (child.startsWith(parent + "/")) return mapToAppPath(child);
  const segments = child.split("/").filter(Boolean);
  if (segments.length > 1) return mapToAppPath(child);
  if (!parent) return mapToAppPath(child);
  return mapToAppPath(`${parent}/${segments[0]}`);
}



// WEBPACK FOOTER //
// ./src/router/routeMap.js